var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertCaution = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 26,
  viewBox: "0 0 28 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#DB371D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.3 25.9 13.7 0 0 25.9zM13.7 4.3 24 23.9H3.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7 11.7v4.8h-2v-4.8z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.7,
  cy: 20.1,
  r: 1.2
}))));
export default SvgAlertCaution;